// Live account reconciliation uses the existing report engine, without revaluing inventory.
const yearClosingInventoryTrial = (model: any, reports: any, chart: any[] = []): any => {
  let invalid = !Array.isArray(reports?.trial)
  const rows = (reports?.trial || []).flatMap((group: any) => group.accounts || []).flatMap((row: any) => {
    const code = String(row.nr || row.code || '')
    const account = chart.find((item) => String(item.code || item.accountNumber) === code)
    const standard = String(account?.equivalentCode || account?.standardAccountCode || account?.yearClosingStandardAccountCode || code).match(/^\d{4}/)?.[0] || ''
    if (!/^14\d{2}$/.test(standard)) return []
    if (typeof row.ut !== 'number' || !Number.isFinite(row.ut)) invalid = true
    return [{ code, name: String(row.name || ''), balance: row.ut }]
  }).sort((a: any, b: any) => a.code.localeCompare(b.code))
  // The per-category split can only post to the fixed NS 4102 account pairs. A
  // business that books inventory on a custom 14xx account keeps the single-total
  // flow and Free Posting, because posting the change to the standard account
  // would leave the balance sitting on the account nobody reconciled.
  const categories = window.PlummeYearClosingInventory.categories
  const categoryRows = categories.map((entry: any) => {
    const row = rows.find((item: any) => item.code === entry.inventoryAccountCode)
    return { ...entry, name: row?.name || '', balance: row ? row.balance : 0 }
  })
  // A negative balance on a single category is a bookkeeping error the split cannot
  // express - declared values are amounts, never signed corrections - so it falls
  // back to the single total and Free Posting rather than blocking on a save error.
  const categorySplitAvailable = rows.every((row: any) => categories.some((entry: any) => entry.inventoryAccountCode === row.code))
    && categoryRows.every((row: any) => row.balance >= 0)
  const ledgerBalance = Math.round(rows.reduce((sum: number, row: any) => sum + row.balance, 0) * 100) / 100
  if (!Number.isFinite(ledgerBalance) || ledgerBalance < 0) invalid = true
  const difference = typeof model.evidence?.bookValue === 'number' ? Math.round((ledgerBalance - model.evidence.bookValue) * 100) / 100 : null
  const reason = !model.supported ? 'unsupported' : invalid ? 'ledgerUnknown'
    : model.status === 'na' && ledgerBalance !== 0 ? 'conflict'
    : model.evidence?.basisToken === model.basisToken && model.evidence?.ledgerBalance !== ledgerBalance ? 'stale'
    : model.status === 'ok' && difference !== 0 ? 'difference' : model.reason
  return { ...model, rows, categoryRows, categorySplitAvailable, ledgerBalance, difference, reason, status: reason === 'reconciled' ? 'ok' : ['notApplicable', 'noSignals'].includes(reason) ? 'na' : 'todo' }
}
window.PlummeYearClosingInventoryTrial = yearClosingInventoryTrial
